import { useState } from 'react';

const useCookie = () => {
  const [hasCookie, setHasCookie] = useState(false);

  function writeCookie(event) {
    if (event.origin.includes(process.env.REACT_APP_DOMAIN)) {
      const url = new URL(document.location.href);
      const token = url.searchParams.get('token');

      document.cookie = `access_token=${token}`;
      localStorage.setItem('language', event.data.language);
      localStorage.setItem('access_token', token);
      
      setHasCookie(true);
    } else if (process.env.NODE_ENV === 'development') {
      return process.env.REACT_APP_TOKEN && setHasCookie(true);
    } else {
      console.error('erro ao setar cookie');
      window.top.location.href =
        `${event.origin}/#/login?expired_token=true`;
    }
  }

  function validateCookie() {
    if (!hasCookie) {
      const getAccessToken = event => writeCookie(event);
      if (window.addEventListener) {
        window.addEventListener('message', getAccessToken.bind(this), false);
      } else {
        window.attachEvent('onmessage', getAccessToken.bind(this));
      }
    }
  }

  return {
    hasCookie,
    validateCookie,
  };
};

export default useCookie;
